import { jsx as r, jsxs as a } from "react/jsx-runtime";
import m from "classnames";
import d from "../../utils/colors.js";
import { a as f } from "../../styled-qu50FBLM.mjs";
import { Svg as c, GElement as o, Elipse as h, Polygon as i } from "./Elements.js";
const g = ({
  className: t = "",
  fill: e = d.blueGrey,
  viewBox: l = "0 0 27 26",
  $cssHelper: s = f,
  focusable: n
}) => /* @__PURE__ */ r(
  c,
  {
    className: m({ [t]: !!t }),
    viewBox: l,
    $cssHelper: s,
    focusable: !!n,
    "aria-hidden": !n,
    children: /* @__PURE__ */ r(o, { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ r(o, { transform: "translate(-30.000000, -94.000000)", children: /* @__PURE__ */ r(o, { transform: "translate(19.000000, 86.000000)", children: /* @__PURE__ */ r(o, { transform: "translate(12.000000, 9.000000)", children: /* @__PURE__ */ a(o, { id: "Icon/Information/White", children: [
      /* @__PURE__ */ r(
        h,
        {
          stroke: e,
          strokeWidth: "2",
          fillRule: "nonzero",
          cx: "12.5",
          cy: "12",
          rx: "12.5",
          ry: "12"
        }
      ),
      /* @__PURE__ */ r(i, { fill: e, points: "11 17 14 17 14 10.8461538 11 10.8461538" }),
      /* @__PURE__ */ r(i, { fill: e, points: "11 9.30769231 14 9.30769231 14 7 11 7" })
    ] }) }) }) }) })
  }
);
export {
  g as default
};
